/**
 * Authentication API Service
 * Handles all authentication-related API calls
 */

import apiService from './apiService';
import { ENDPOINTS } from './endpoints';
import { initializeSession } from './sessionService';

/**
 * Login with email and password
 * @param {string} email - User email
 * @param {string} password - User password
 * @returns {Promise} Login response with token
 */
export const loginWithCredentials = async (email, password) => {
  try {
    const response = await apiService.post(ENDPOINTS.AUTH.LOGIN, {
      email,
      password,
    });

    if (response.data.token) {
      initializeSession(response.data.token);
    }

    return response.data;
  } catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
};

/**
 * Initiate SAML Single Sign-On
 * @returns {Promise} SSO initialization response
 */
export const initiateSAMLSSO = async () => {
  try {
    const response = await apiService.get(ENDPOINTS.AUTH.SAML_INIT);
    return response.data;
  } catch (error) {
    console.error('SAML initiation failed:', error);
    throw error;
  }
};

/**
 * Finalize SAML Single Sign-On
 * @param {string} sessionIndex - SAML session index
 * @returns {Promise} SSO finalization response with token
 */
export const finalizeSAMLSSO = async (sessionIndex) => {
  try {
    const response = await apiService.get(ENDPOINTS.AUTH.SAML_FINALIZE, {
      params: { session_index: sessionIndex },
    });

    if (response.data.token) {
      initializeSession(response.data.token);
    }

    return response.data;
  } catch (error) {
    console.error('SAML finalization failed:', error);
    throw error;
  }
};

export default {
  loginWithCredentials,
  initiateSAMLSSO,
  finalizeSAMLSSO,
};
